import buildService, { NoParams } from 'common/utils/build-service'
import { GET, PATCH, POST } from 'common/requests'

interface JournalsUrlParams {
  personId?: string
}

interface JournalIdParams {
  id: string
}

export const getJournalsService = buildService<JournalsUrlParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'JOURNALS',
  isArray: true,
  http: {
    createApiUrlSuffix: ({ personId }) => {
      if (personId) {
        return `/journals?person_id=eq.${personId}`
      }
      return '/journals'
    },
  },
})

export const postJournalService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'CREATE_JOURNAL',
  http: {
    createApiUrlSuffix: () => '/journals',
    headers: {
      Prefer: 'params=single-object',
    },
  },
})

export const patchJournalService = buildService<JournalIdParams, unknown, unknown, unknown>({
  type: PATCH,
  constantsPrefix: 'CREATE_JOURNAL',
  http: {
    createApiUrlSuffix: ({ id }) => `/journals?id=eq.${id}`,
    headers: {
      Prefer: 'params=single-object',
    },
  },
})
